import React from 'react';
import styled, { css } from 'styled-components';
import propTypes from 'prop-types';
import editorStyles from './editorStyles';

const CenterToolbarWrapper = styled.ul`
  grid-column: 5/9;
  height: inherit;
  align-self: flex-start;
  display: flex;
  justify-content: center;
  list-style: none;
  margin-bottom: 0;

  ${(props) => {
    const { pathname } = props;
    if (!pathname.includes('/documents/')) {
      return css`
        display: none;
      `;
    }

    const editorPageStyles = editorStyles(pathname);
    if (editorPageStyles) return editorPageStyles;

    return null;
  }}
`;

const CenterToolbar = (props) => {
  const { children, pathname, dataTestId } = props;

  return (
    <CenterToolbarWrapper pathname={pathname} data-testid={dataTestId}>
      {children}
    </CenterToolbarWrapper>
  );
};

CenterToolbar.propTypes = {
  children: propTypes.node.isRequired,
  pathname: propTypes.string.isRequired,
};

export default CenterToolbar;
